export default __webpack_public_path__ + "static/media/instagram.9f71d239.png";